export default "__VITE_ASSET__BfqKwxIS__"